import { useInfiniteQuery } from "@tanstack/react-query"

import { getMotibellMainList } from "lib/api/motibell/getMotibellMainList"

const LIMIT = 20

const useGetMotibellMainListQuery = ({ userNo, status, currDate }, options) => {
  return useInfiniteQuery(
    createKey(userNo),
    ({ pageParam = undefined }) => getMotibellMainList({ status, currDate, offset: pageParam }),
    {
      getNextPageParam: (lastPage, allPage) => {
        return lastPage.data.motibells.length === LIMIT ? allPage.length * LIMIT : undefined
      },
      ...options,
    }
  )
}

const createKey = (userNo) => ["motibellMainList", userNo ?? undefined]

export default useGetMotibellMainListQuery
